// Core data models

export interface Participant {
  id: string;
  name: string;
  groupId: string;
}

export interface Group {
  id: string;
  name: string;
  representativeId: string;
  participantIds: string[];
}

export interface Expense {
  id: string;
  description: string;
  amount: number; // Stored in cents to avoid floating point issues
  paidById: string;
  participantIds: string[];
  createdAt: string;
}

export interface Event {
  id: string;
  name: string;
  currency: CurrencyCode;
  createdAt: string;
  updatedAt: string;
  participants: Participant[];
  groups: Group[];
  expenses: Expense[];
}

// Derived types for calculations

export interface ParticipantBalance {
  participantId: string;
  participantName: string;
  groupId: string;
  balance: number; // Positive = is owed money, Negative = owes money
}

export interface GroupBalance {
  groupId: string;
  groupName: string;
  representativeId: string;
  representativeName: string;
  totalBalance: number;
}

export interface Transfer {
  fromGroupId: string;
  fromGroupName: string;
  fromRepresentativeId: string;
  fromRepresentativeName: string;
  toGroupId: string;
  toGroupName: string;
  toRepresentativeId: string;
  toRepresentativeName: string;
  amount: number;
}

// Storage types

export interface StorageData {
  version: number;
  events: Event[];
}

// Currency options

export const CURRENCIES = [
  { code: 'ARS', symbol: '$', name: 'Peso Argentino' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'BRL', symbol: 'R$', name: 'Real Brasileño' },
  { code: 'CLP', symbol: '$', name: 'Peso Chileno' },
  { code: 'MXN', symbol: '$', name: 'Peso Mexicano' },
  { code: 'UYU', symbol: '$', name: 'Peso Uruguayo' },
] as const;

export type CurrencyCode = (typeof CURRENCIES)[number]['code'];
